/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const FilterIcon = createIcon({
  displayName: "FilterIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 0.75V7.25H4.75V4.75H0.75V3.25H4.75V0.75H6.25ZM7.75 3.25H15.25V4.75H7.75V3.25ZM11.25 8.75V11.25H15.25V12.75H11.25V15.25H9.75V8.75H11.25ZM0.75 11.25H8.25V12.75H0.75V11.25Z"
        fill="currentColor"
      />
    </g>
  )
});
